import Index from '../components/CuriosityOrder/Index';

let routes = {
    path: '/curiosityOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/curiosityOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/curiosityOrder.js